function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { translateFieldName, objectifyParameters, getNewURL, translate } from '../utils/helpers';
import SidebarFilter from './SidebarFilter';
import { Link } from 'react-router-dom';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import _trimEnd from 'lodash/trimEnd';
import CalculatorModal from './CalculatorModal';

var Sidebar = /*#__PURE__*/function (_Component) {
  _inherits(Sidebar, _Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSubSubCategoriesProductsSum", function (subSubCategories) {
      return subSubCategories.reduce(function (previous, current) {
        return previous + current.products_count;
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "getSubSubCategoryString", function (categoryId, subCategoryId) {
      var subSubCategoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return _trimEnd([categoryId, subCategoryId, subSubCategoryId].join('+'), '+');
    });

    _defineProperty(_assertThisInitialized(_this), "isActiveCategory", function (categoryId) {
      return _this.objectifiedParameters.category !== undefined && _this.objectifiedParameters.category.length === 1 && parseInt(_this.objectifiedParameters.category[0], 10) === categoryId;
    });

    _defineProperty(_assertThisInitialized(_this), "isActiveSubCategory", function (subCategoryId) {
      return _this.objectifiedParameters.category !== undefined && _this.objectifiedParameters.category.length === 2 && parseInt(_this.objectifiedParameters.category[1], 10) === subCategoryId;
    });

    _defineProperty(_assertThisInitialized(_this), "isActiveSubSubCategory", function (subSubCategoryId) {
      return _this.objectifiedParameters.category !== undefined && _this.objectifiedParameters.category.length > 2 && parseInt(_this.objectifiedParameters.category[2], 10) === subSubCategoryId;
    });

    _defineProperty(_assertThisInitialized(_this), "orderByName", function (categories) {
      return _orderBy(categories, [function (category) {
        return _deburr(category[translateFieldName('name')].toLowerCase());
      }]);
    });

    _defineProperty(_assertThisInitialized(_this), "updateParams", function () {
      _this.objectifiedParameters = objectifyParameters(_this.props.match.params);
      _this.categoryLevel = _this.objectifiedParameters.category && _this.objectifiedParameters.category.length || 0;
    });

    _defineProperty(_assertThisInitialized(_this), "isNoCategoryActive", function () {
      return _this.categoryLevel === 0;
    });

    _defineProperty(_assertThisInitialized(_this), "isCategoryActive", function () {
      return _this.categoryLevel === 1;
    });

    _defineProperty(_assertThisInitialized(_this), "isSubCategoryActive", function () {
      return _this.categoryLevel === 2;
    });

    _defineProperty(_assertThisInitialized(_this), "isSubSubCategoryActive", function () {
      return _this.categoryLevel === 3;
    });

    _defineProperty(_assertThisInitialized(_this), "isInoSupplierActive", function () {
      return _this.objectifiedParameters.suppliers && _this.objectifiedParameters.suppliers.length === 1 && _this.objectifiedParameters.suppliers[0] === '1';
    });

    _this.updateParams();

    return _this;
  }

  _createClass(Sidebar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.match.params !== this.props.match.params) {
        this.updateParams();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          categories = _this$props.categories,
          certifications = _this$props.certifications,
          families = _this$props.families,
          loadingProduct = _this$props.loadingProduct,
          shopType = _this$props.shopType;
      return !loadingProduct ? /*#__PURE__*/React.createElement("div", {
        className: "Sidebar"
      }, /*#__PURE__*/React.createElement(Link, {
        className: "back-to-all-categories main-txt-hover",
        to: "/page/categories"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-fw fa-angle-left"
      }), translate('All Products', 'Tous les produits'))), !this.isInoSupplierActive() && categories.map(function (category) {
        return /*#__PURE__*/React.createElement("div", {
          className: "Sidebar-category",
          key: category.id
        }, /*#__PURE__*/React.createElement(Link, {
          to: getNewURL(_this2.objectifiedParameters, 'category', category.id, true),
          className: "Sidebar-category-name  main-txt-hover ".concat(_this2.isActiveCategory(category.id) ? 'active' : '')
        }, _this2.isSubCategoryActive() || _this2.isSubSubCategoryActive() ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-fw fa-angle-left"
        }) : null, /*#__PURE__*/React.createElement("span", null, category[translateFieldName('name')])), !_this2.isNoCategoryActive() ? _this2.orderByName(category.sub_categories).map(function (subCategory) {
          return /*#__PURE__*/React.createElement("div", {
            className: "Sidebar-subCategory",
            key: subCategory.id
          }, /*#__PURE__*/React.createElement(Link, {
            className: "Sidebar-subCategory-name main-txt-hover ".concat(_this2.isActiveSubCategory(subCategory.id) ? 'active' : ''),
            to: getNewURL(_this2.objectifiedParameters, 'category', _this2.getSubSubCategoryString(category.id, subCategory.id), true)
          }, _this2.isSubSubCategoryActive() ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-fw fa-angle-left"
          }) : null, /*#__PURE__*/React.createElement("span", null, subCategory[translateFieldName('name')], ' ', _this2.categoryLevel !== 'SUB_SUB_CATEGORY' ? /*#__PURE__*/React.createElement("span", {
            className: "counter"
          }, "(", _this2.getSubSubCategoriesProductsSum(subCategory.sub_sub_categories), ")") : null)), _this2.isSubCategoryActive() || _this2.isSubSubCategoryActive() ? /*#__PURE__*/React.createElement("div", {
            className: "Sidebar-subSubCategories"
          }, _this2.orderByName(subCategory.sub_sub_categories).map(function (subSubCategory) {
            return /*#__PURE__*/React.createElement("div", {
              key: subSubCategory.id
            }, /*#__PURE__*/React.createElement(Link, {
              className: "main-txt-hover main-box-hover ".concat(_this2.isActiveSubSubCategory(subSubCategory.id) ? 'active' : ''),
              to: getNewURL(_this2.objectifiedParameters, 'category', _this2.getSubSubCategoryString(category.id, subCategory.id, subSubCategory.id), true)
            }, /*#__PURE__*/React.createElement("span", null, subSubCategory[translateFieldName('name')]), /*#__PURE__*/React.createElement("span", {
              className: "counter"
            }, "(", subSubCategory.products_count, ")")));
          })) : null);
        }) : null);
      }), this.isSubSubCategoryActive() && this.isActiveSubSubCategory(5) ? /*#__PURE__*/React.createElement("div", {
        className: "calculator-section second-bg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "main-title"
      }, translate('Calculator', 'Calculateurs').toUpperCase()), /*#__PURE__*/React.createElement("span", {
        className: "sub-title"
      }, translate('of dimensions for garbage bags', 'de dimension de sacs à ordures').toUpperCase())), /*#__PURE__*/React.createElement("div", {
        className: " btn btn-dark",
        "data-toggle": "modal",
        "data-target": "#CalculatorModal"
      }, translate('Discover tools', 'Découvrez les outils').toUpperCase()), /*#__PURE__*/React.createElement(CalculatorModal, null)) : null, this.isSubSubCategoryActive() || shopType !== 'category' ? /*#__PURE__*/React.createElement("div", {
        className: "filter-sidebar-container"
      }, shopType !== 'certifications' ? /*#__PURE__*/React.createElement(SidebarFilter, {
        filters: certifications,
        titleEn: 'Certifications',
        titleFr: 'Certifications',
        slug: 'certifications'
      }) : null, /*#__PURE__*/React.createElement(SidebarFilter, {
        filters: families,
        titleEn: 'INO Families',
        titleFr: 'Familles INO',
        slug: 'families'
      })) : null) : null;
    }
  }]);

  return Sidebar;
}(Component);

Sidebar.propTypes = {
  categories: PropTypes.array,
  certifications: PropTypes.array,
  families: PropTypes.array,
  loadingProduct: PropTypes.bool,
  location: PropTypes.object,
  match: PropTypes.object,
  shopType: PropTypes.string,
  suppliers: PropTypes.array
};
export default withRouter(Sidebar);